/** * * Asynchronously loads the component for
Blog Detail
* */ import { lazyLoad } from "utils/loadable";
export const BlogDetail = lazyLoad(
  () => import("./index"),
  (module) => module.BlogDetail
);
